import { render, staticRenderFns } from "./InwardFreightAirFreightComponent.vue?vue&type=template&id=5c94bc7d"
import script from "./InwardFreightAirFreightComponent.vue?vue&type=script&lang=js"
export * from "./InwardFreightAirFreightComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports